import React from 'react';
import { iconValid } from '../../helpers';
import { Spacer } from '../Spacer/Spacer';
import { StyledTag, Close, ChildWrapper } from './styles';
const Tag = props => {
  const {
    theme,
    selectedTheme,
    text,
    textSize,
    textColor,
    verticalPadding,
    horizontalPadding,
    bgColor,
    borderSize,
    borderColor,
    borderRadius,
    removable,
    iconLeft,
    closeIcon,
    closeSize,
    closeColor,
    callback,
    pill,
    round,
    allClick,
    children
  } = props;
  return /*#__PURE__*/React.createElement(StyledTag, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    $textColor: textColor,
    $bgColor: bgColor,
    $pill: pill,
    $round: round,
    $verticalPadding: verticalPadding,
    $horizontalPadding: horizontalPadding,
    $removable: removable,
    $textSize: textSize,
    $borderSize: borderSize,
    $borderColor: borderColor,
    $borderRadius: borderRadius,
    $iconLeft: iconLeft,
    $allClick: allClick,
    onClick: e => allClick && removable && callback?.(e)
  }, removable && iconLeft && /*#__PURE__*/React.createElement(Close, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    $closeSize: closeSize,
    $closeColor: closeColor,
    onClick: e => !allClick && callback?.(e)
  }, !iconLeft && /*#__PURE__*/React.createElement(Spacer, {
    size: horizontalPadding || 1,
    across: true
  }), iconValid(closeIcon) ? /*#__PURE__*/React.createElement("i", {
    className: `${iconValid(closeIcon)}`
  }) : closeIcon || /*#__PURE__*/React.createElement("i", {
    className: "fa-solid fa-circle-xmark"
  }), iconLeft && /*#__PURE__*/React.createElement(Spacer, {
    size: horizontalPadding || 1,
    across: true
  })), /*#__PURE__*/React.createElement(ChildWrapper, null, text || children), removable && !iconLeft && /*#__PURE__*/React.createElement(Close, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    $closeSize: closeSize,
    $closeColor: closeColor,
    onClick: () => !allClick && callback?.()
  }, !iconLeft && /*#__PURE__*/React.createElement(Spacer, {
    size: horizontalPadding || 1,
    across: true
  }), iconValid(closeIcon) ? /*#__PURE__*/React.createElement("i", {
    className: `${iconValid(closeIcon)}`
  }) : closeIcon || /*#__PURE__*/React.createElement("i", {
    className: "fa-solid fa-circle-xmark"
  }), iconLeft && /*#__PURE__*/React.createElement(Spacer, {
    size: horizontalPadding || 1,
    across: true
  })));
};
export { Tag };